export default [
  {
    image: '/images/main/awards/gra.png',
    title: 'footer.awards.gra.title',
    text: 'footer.awards.gra.text',
    type: 'gra',
  },
  {
    image: '/icons/main/awards/cts.svg',
    title: 'footer.awards.cts.title',
    type: 'cts',
  },
];
